import { Store } from '@ngrx/store';

import { NotificationCommandsInterface } from '../public/public.port';
import { CloseNotification } from '../state/notification.actions';

import { NotificationCommand, NotificationCommands } from './notification.command';

import { Command } from '@core/domain/ports/primary/cqrs/command.interface';
import { NotificationCommandProps } from '@features/notification/domain/models/notification.models';

export class NotificationCommandsFacade implements NotificationCommandsInterface {
    private readonly store: Store;

    constructor(store: Store) {
        this.store = store;
    }

    public openNotification(props: NotificationCommandProps): void {
        const notificationCommand: Command<NotificationCommandProps> = {
            module: 'NotificationCoreModule',
            path: () => import('@features/notification/notification.module').then((m) => m.NotificationCoreModule),
            key: NotificationCommands.OPEN_NOTIFICATION,
            props,
        };

        const notificationCommandHandler = new NotificationCommand(this.store);
        notificationCommandHandler.handle(notificationCommand);
    }

    public closeNotification() {
        this.store.dispatch(CloseNotification());
    }
}
